import { gql } from "@apollo/client";

export const todayProductData = {
  productCode: "",
  productName: "",
  productCategory: "",
  productBrand: "",
  productBrandCode: "",
  vat: "",
  productUom: "",
  baseUom: "",
  conversion: "",
  currentstock: "",
  stockInPart: "",
  pcs: "",
  soldStock: "",
  productImage: null,
  productCodeStatus: "unchecked",
  productNameStatus: "unchecked",
  productCategoryStatus: "unchecked",
  productBrandStatus: "unchecked",
  productUomStatus: "unchecked",
  baseUomStatus: "unchecked",
  vatStatus: "unchecked",
  productBrandCodeStatus: "unchecked",
  conversionStatus: "unchecked",
  currentstockStatus: "unchecked",
  stockInPartStatus: "unchecked",
  pcsStatus: "unchecked",
  soldStockStatus: "unchecked",

  productImageStatus: false,
};

export const todayProductDataMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;
  switch (inputName) {
    case "productCode": {
      if (value) {
        return {
          ...state,
          productCode: value,
          productCodeStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productCode: "",
          productName: "",
          productCategory: "",
          productBrand: "",
          productBrandCode: "",
          vat: "",
          productUom: "",
          baseUom: "",
          conversion: "",
          productCodeStatus: "unchecked",
          productNameStatus: "unchecked",
          productCategoryStatus: "unchecked",
          productBrandStatus: "unchecked",
          productUomStatus: "unchecked",
          baseUomStatus: "unchecked",
          vatStatus: "unchecked",
          productBrandCodeStatus: "unchecked",
          conversionStatus: "unchecked",
        };
      }
    }
    case "productName": {
            const alphaNLenghthRegex = /^.{1,10000}$/;


      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          productName: value,
          productNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productName: "",
          productNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          productName: value,
          productNameStatus: "error",
        };
      }
    }

    case "productCategory": {
      // const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9]{1,15})$");
      const alphaNLenghthRegex = /^.{1,10000}$/;
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          productCategory: value,
          productCategoryStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productCategory: "",
          productCategoryStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          productCategory: value,
          productCategoryStatus: "error",
        };
      }
    }
    case "productBrand": {
          const alphaNLenghthRegex = /^.{1,10000}$/;

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          productBrand: value,
          productBrandStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productBrand: "",
          productBrandStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          productBrand: value,
          productBrandStatus: "error",
        };
      }
    }
    case "productBrandCode": {
            const alphaNLenghthRegex = /^.{1,10000}$/;

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          productBrandCode: value,
          productBrandCodeStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productBrandCode: "",
          productBrandCodeStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          productBrandCode: value,
          productBrandCodeStatus: "error",
        };
      }
    }
    case "vat": {
      const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9]{1,15})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          vat: value,
          vatStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          vat: "",
          vatStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          vat: value,
          vatStatus: "error",
        };
      }
    }
    case "productUom": {
      const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9]{1,15})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          productUom: value,
          productUomStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productUom: "",
          productUomStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          productUom: value,
          productUomStatus: "error",
        };
      }
    }
    case "baseUom": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          baseUom: value,
          baseUomStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          baseUom: "",
          baseUomStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          baseUom: value,
          baseUomStatus: "error",
        };
      }
    }
    case "conversion": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          conversion: value,
          conversionStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          conversion: "",
          conversionStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          conversion: value,
          conversionStatus: "error",
        };
      }
    }
    case "stockInPart": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          stockInPart: value,
          stockInPartStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          stockInPart: "",
          stockInPartStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          stockInPart: value,
          stockInPartStatus: "error",
        };
      }
    }
    case "currentstock": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          currentstock: value,
          currentstockStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          currentstock: "",
          currentstockStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          currentstock: value,
          currentstockStatus: "error",
        };
      }
    }
    case "pcs": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          pcs: value,
          pcsStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          pcs: "",
          pcsStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          pcs: value,
          pcsStatus: "error",
        };
      }
    }

    case "productImage": {
      if (value) {
        return {
          ...state,
          productImage: value,
          productImageStatus: true,
        };
      } else if (!value) {
        return {
          ...state,
          productImage: null,
          productImageStatus: false,
        };
      }
    }

    default:
      return state;
  }
};

export const todayProductFilterState = {
  fromDate: null,
  toDate: null,

  // status
  fromDateStatus: "unchecked",
  toDateStatus: "unchecked",
};

export const TodayProductFilterStateStateMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "reset": {
      return { ...todayProductFilterState }; // Return the initial state
    }
    case "fromDate": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          fromDate: value,
          fromDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          fromDate: null,
          fromDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          fromDate: value,
          fromDateStatus: "error",
        };
      }
    }
    case "toDate": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          toDate: value,
          toDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          toDate: null,
          toDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          toDate: value,
          toDateStatus: "error",
        };
      }
    }
    default:
      return state;
  }
};

export const createtodayproduct = gql`
  mutation createtodayproduct($input: CreateTodayProductInput!) {
    createTodayProduct(input: $input) {
      success
      message
    }
  }
`;

export const updatetodayproduct = gql`
  mutation updatetodayproduct($input: UpdateTodayProductInput!) {
    updateTodayProduct(input: $input) {
      success
      message
    }
  }
`;

export const deletetodayproduct = gql`
  mutation deletetodayproduct($id: ID!) {
    deleteTodayProduct(id: $id) {
      success
      message
    }
  }
`;

export const uploadTodayProduct = gql`
  mutation uploadtodayproducts($file: Upload!, $userId: Int!) {
    uploadTodayProduct(file: $file, userId: $userId) {
      success

      message
    }
  }
`;

export const exportTodayProduct = gql`
  mutation {
    exportTodayProduct {
      success
      fileUrl
    }
  }
`;

export const todayDateProducts = gql`
  query GetTodayProducts($page: Int, $pageSize: Int, $search: String) {
    todayDateProducts(page: $page, pageSize: $pageSize, search: $search) {
      success
      message
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
      data {
        id
        productCode
        productName
        productCategory
        productBrand
        productUom
        soldStock
        currentStock
        originalStock
        conversion
        stockInCtn
        stockInPart
        createdAt
        user {
          employeeName
        }
      }
    }
  }
`;

export const pastDateProducts = gql`
  query PastDateProducts(
    $page: Int
    $pageSize: Int
    $search: String
    $startDate: Date
    $endDate: Date
    $categories: [String]
    $brands: [String]
    $products: [String]
  ) {
    pastDateProducts(
      page: $page
      pageSize: $pageSize
      search: $search
      startDate: $startDate
      endDate: $endDate
      categories: $categories
      brands: $brands
      products: $products
    ) {
      success
      message
      totalCount
      currentPage
      totalPages
      data {
        id
        productCode
        productName
        productCategory
        productBrand
        productUom
        soldStock
        currentStock
        originalStock
        conversion
        stockInCtn
        stockInPart
        createdAt
        user {
          employeeName
        }
      }
    }
  }
`;

export const filderDateWise = gql`
  query FilterProducts(
    $startDate: Date!
    $endDate: Date!
    $categories: [String]
    $brands: [String]
    $products: [String]
    $page: Int
    $pageSize: Int
  ) {
    filterProducts(
      startDate: $startDate
      endDate: $endDate
      categories: $categories
      brands: $brands
      products: $products
      page: $page
      pageSize: $pageSize
    ) {
      success
      message
      totalCount
      totalPages
      currentPage
      hasNextPage
      hasPreviousPage
      data {
        id
        productName
        productCategory
        productBrand
        productUom
        soldStock
        createdAt
      }
    }
  }
`;

export const exportPastDateProducts = gql`
  mutation ExportPastDateProducts($startDate: Date!, $endDate: Date!) {
    exportPastProduct(startDate: $startDate, endDate: $endDate) {
      success
      fileUrl
      message
    }
  }
`;
export const allProductsDropdown = gql`
  query {
    allProductsDropdown {
      success
      message
      data {
        id
        productCode
        productName
        productCategory
        productBrand
        productBrandCode
        productUom
        baseUom
        conversion
        vat
        bas
        cod
        csh
        smt
        vansl
        createdAt
        lastupdate
      }
    }
  }
`;
